import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { ThemeDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-theme-select',
  templateUrl: './theme-select.component.html',
  styleUrls: ['./theme-select.component.css']
})
export class ThemeSelectComponent implements OnInit {

  @Select(ControlPanelStore.themes$) themes$: Observable<ThemeDto[]>;

  @Input('width') width: number;

  @Input() disabled: boolean = false;
  
  @Input() themeId: number;
  @Output() themeIdChange = new EventEmitter<number>();

  @Input() cell: any;

  InitId = null;

  Themes: ThemeDto[] = [];

  p: Subscription;


  constructor(private panelLayoutService: PanelLayoutService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
      // Instanciate Globalize for DevExtreme components
      this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());
    }

  ngOnInit(): void {
    if(this.themeId != null) {
      this.InitId = JSON.parse(JSON.stringify(this.themeId));
    }
    this.p = this.themes$.subscribe(res => {
      if (res != null) {
        this.Themes = res;
      }
    });
  }

  ngOnDestroy() {
    this.p?.unsubscribe();
  }

  updateInfo(event) {
    if (!!this.cell && this.InitId != this.themeId) {
      this.cell.setValue(this.themeId);
    }
    this.themeIdChange.emit(this.themeId);
  }

}
